import React from 'react'
import gql from 'graphql-tag'
import {shouldShowDeliveredPhotos} from 'lib/productHelpers'
import ConfirmInputAssets from 'components/shared/ConfirmInputAssets'
import DeliveredPhotos from 'components/shared/DeliveredPhotos'
import DefaultProductStatus from '../../DefaultProductStatus'

const RetouchedEveningPhotoProduct = ({match, product, viewer}) => {
  const choosePhotosDescriptionText = () => {
    const inputAssetsLength = product.inputAssets.edges.length
    const minQuantity = product.quantity

     let description = inputAssetsLength > 1
      ? 'Vi har tatt flere bilder.'
      : 'Vi har tatt ett bilde.'

     description += minQuantity > 1
      ? ` Velg ut de ${minQuantity} du vil ha redigert.`
      : ' Velg det du vil ha redigert.'

     if (inputAssetsLength > minQuantity) {
      description += ` Du kan velge flere enn ${minQuantity}, da vil ekstrakostnaden bli lagt til ordren.`
    }

     return description
  }

  const getCostForInputAssets = (selectedPhotos) => {
    const {remainingCredits, extraAssetUnitPrice} = product
    return (selectedPhotos.length - remainingCredits) * extraAssetUnitPrice
  }

  if (product.canProvideUserInput) {
    return (
      <ConfirmInputAssets
        estateId={match.params.estateId}
        product={product}
        minQuantity={product.quantity}
        descriptionText={choosePhotosDescriptionText()}
        getTotalCost={getCostForInputAssets}
      />
    )
  }

  if (shouldShowDeliveredPhotos(product)) {
    const photoOrder = viewer.photoOrderPreference.edges.map(edge => edge.node.name)
    return (
      <DeliveredPhotos
        estateId={match.params.estateId}
        product={product}
        photoOrder={photoOrder}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

RetouchedEveningPhotoProduct.fragment = gql`
  fragment RetouchedEveningPhotoProduct on RetouchedEveningPhotoProduct {
    inputAssets {
      edges {
        node {
          id
          ...on PhotoAsset {
            image(size: "monitor") {
              url
              thumbUrl
              width
              height
              labels
              filenameIndex
            }
          }
        }
      }
    }
  }
`

export default RetouchedEveningPhotoProduct
